<button type="button" class="btn btn-logo-color btn-just-icon scroll-top" (click)="scrollTop()">
    <i class="fa fa-arrow-up"></i>
</button>